import PropTypes from 'prop-types';
import { Box, Typography, Divider, Paper } from '@mui/material';

/**
 * Renders bank details including bank name, account number, CBU, CUIT, legal name, and checking account information.
 *
 * @param {Object} bankAccount - Object containing bank details like bankName, accountNumber, cbu, cuit, legalName, and checkingAccount.
 * @returns {JSX.Element} Bank details component with specified styling and layout.
 */
const BankDetails = ({ bankAccount }) => {
  const { bankName, accountNumber, cbu, cuit, legalName, checkingAccount } = bankAccount;
  return (
    <Paper sx={{ padding: 2, backgroundColor: '#f9f9f9' }}>
      <Divider sx={{ mb: 2 }} />
      <Typography
        variant="h2"
        style={{ fontSize: '1.5em', fontWeight: 'bold' }}
        align="center"
        gutterBottom
      >
        Datos Bancarios:
      </Typography>
      <Box sx={{ textAlign: 'left', padding: 2 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
          BANCO: {bankName}
        </Typography>
        {checkingAccount && (
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            CUENTA CORRIENTE Nº: {checkingAccount}
          </Typography>
        )}
        {accountNumber && (
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            NÚMERO DE CUENTA: {accountNumber}
          </Typography>
        )}
        {legalName && (
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            RAZÓN SOCIAL: {legalName}
          </Typography>
        )}
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
          CBU: {cbu}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
          CUIT: {cuit}
        </Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />
    </Paper>
  );
};

BankDetails.propTypes = {
  bankAccount: PropTypes.object.isRequired,
};

export default BankDetails;
